import { isNil } from 'lodash-es'
import { createDictManager } from 'v-dict'

import { dictApi } from '#/api'

function isEmptyDictValue(value: unknown) {
  return isNil(value) || (typeof value === 'string' && value.trim() === '')
}

export const dm = createDictManager({
  fetch: (code) => dictApi.getDictMerged([code]).then((res) => res[code]!),
  extra: (dict) => {
    const getSingleLabel = (value: any) => dict.map[String(value)]?.label

    return {
      getLabel: (value: any) => {
        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '-'
          }

          const labels = value
            .filter((item) => !isEmptyDictValue(item))
            .map((item) => getSingleLabel(item))
            .filter((item): item is string => !!item)

          return labels.length > 0 ? labels.join(',') : '-'
        }

        if (isEmptyDictValue(value)) {
          return '-'
        }

        return getSingleLabel(value)
      },
      getItem: (value: any) => {
        return dict.list.find((item) => item.value === value)
      },
    }
  },
})
